export const isEmptySlot = (slot: any) => {
    if (!slot) return true;
    if (typeof slot !== 'function') return false;

    return isEmptyNode(slot());
};

function isEmptyNode(nodes: any) {
    return nodes.every((node: any) => {
        if (!node.children || node.children === '') return true;
        return false;
    });
}
